import type { Rect } from '~/types/pipeline';
import type { BoxRef } from '~/types/selection';
import type { GridSlice } from './slice';

/** Minimal grid fields needed to compute cell rectangles. */
type CellRectsInput = Pick<GridSlice['grid'], 'cropRect' | 'rowDividers' | 'colDividers'>;

export function getCellRects(grid: CellRectsInput): Array<{ box: BoxRef; rect: Rect }> {
  const { cropRect, rowDividers: rawRows, colDividers: rawCols } = grid;
  if (!cropRect) return [];

  const colDividers = rawCols ?? [cropRect.x, cropRect.x + cropRect.w];
  const rowDividers = rawRows ?? [cropRect.y, cropRect.y + cropRect.h];

  if (colDividers.length < 2 || rowDividers.length < 2) return [];

  const result: Array<{ box: BoxRef; rect: Rect }> = [];
  for (let row = 0; row < rowDividers.length - 1; row++) {
    const y0 = rowDividers[row];
    const y1 = rowDividers[row + 1];
    if (y0 === undefined || y1 === undefined) continue;
    for (let col = 0; col < colDividers.length - 1; col++) {
      const x0 = colDividers[col];
      const x1 = colDividers[col + 1];
      if (x0 === undefined || x1 === undefined) continue;
      result.push({
        box: { row, col },
        rect: {
          x: x0,
          y: y0,
          w: x1 - x0,
          h: y1 - y0,
        },
      });
    }
  }
  return result;
}
